/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Sso_UnavailableInputs */

const fr_api_sso_unavailable = /** @type {(inputs: Api_Sso_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La connexion est indisponible. Contactez un administrateur.`)
};

const en_api_sso_unavailable = /** @type {(inputs: Api_Sso_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign-in is unavailable. Contact an administrator.`)
};

/**
* | output |
* | --- |
* | "Sign-in is unavailable. Contact an administrator." |
*
* @param {Api_Sso_UnavailableInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_sso_unavailable = /** @type {((inputs?: Api_Sso_UnavailableInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Sso_UnavailableInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_sso_unavailable(inputs)
	return fr_api_sso_unavailable(inputs)
});